import React from "react";

const Features = () => {
  return (
    <section
      id="features"
      className="py-16 md:py-24 bg-gray-50 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Feature 1 - Operasional lebih tertata */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mb-20 md:mb-24">
          <div className="text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Operasional
              <br />
              lebih tertata
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-8">
              Pembayaran IPL & Tagihan perumahan secara digital dan transparan.
            </p>
          </div>
          <div className="w-full max-w-[550px] h-[380px] md:h-[500px] mx-auto">
            <img src="/assets/1.png" alt="Phone Tagihan" />
          </div>
        </div>

        {/* Feature 2 - Data terpusat & transparan */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mb-32 md:mb-24">
          <div className="order-2 md:order-1 w-full max-w-[530px] h-[400px] md:h-[560px] mx-auto">
            <img src="/assets/2.png" alt="Phone QR" />
          </div>
          <div className="order-1 md:order-2 text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Data terpusat
              <br />& transparan
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-4">
              Pengajuan surat dan perizinan dilakukan online, lebih praktis.
            </p>
            <p className="text-lg md:text-xl text-gray-600">
              Pesan fasilitas perumahan tanpa bentrok jadwal.
            </p>
          </div>
        </div>

        {/* Feature 3 - Komunikasi Lebih efektif */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mb-32 md:mb-24">
          <div className="text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Komunikasi
              <br />
              Lebih efektif
            </h2>
            <p className="text-lg md:text-xl text-gray-600">
              Ajukan dan pantau keluhan langsung dari aplikasi.
            </p>
          </div>
          <div className="relative w-full max-w-[260px] md:max-w-[360px] h-[340px] md:h-[500px] mx-auto">
            <img src="/assets/3.png" alt="Phone Buat Pengaduan" />
          </div>
        </div>

        {/* Feature 4 - Keamanan lebih terkontrol */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center mt-10">
          <div className="order-2 md:order-1 relative w-full max-w-[300px] md:max-w-[420px] h-[350px] md:h-[500px] mx-auto">
            <img src="/assets/4.png" alt="Phone Darurat" />
          </div>
          <div className="order-1 md:order-2 text-left">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Keamanan
              <br />
              lebih terkontrol
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-4">
              Kontrol keluar masuk tamu dengan sistem QR yang aman.
            </p>
            <p className="text-lg md:text-xl font-semibold text-gray-900">
              Kontak Darurat
            </p>
            <p className="text-lg md:text-xl text-gray-600">
              Akses cepat ke keamanan dan pengelola dalam satu sentuhan
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
